import httpApi from '../../hooks/api/httpApi';
import { MplShippingInformation } from '../../models/ppoints/MplShippingInformation';
import SettingService from '../../features/settings/services/SettingService';
import { SettingKey } from '../../data/ppoints/constants';
import ApiKeyService from '../settings/ppoints/ApiKeyService';
import { MplPostShipmentsResponse } from '../../models/ppoints/MplPostShipmentsResponse';
import { MplClosedShipmentData } from '../../models/ppoints/MplClosedShipmentData';
import { ShopifyOrder } from '../../features/orders/models/ShopifyOrder';
import { ShippingType } from '../../features/orders/models/ShippingType';
import OrderService from '../../features/orders/services/OrderService';
import { MplOrderStatus } from '../../models/ppoints/MplOrderStatus';
import { downloadFileContent } from '../../utils/utils';
import { Order } from 'models/Order';
import { MplApiKeysSetting } from 'models/ppoints/settings/SettingsToEcom';

let store;
const injectStore = (_store) => {
    store = _store;
};

const isApiKeyValid = async (ecomId: number): Promise<boolean> => {
    const apiTestMode: boolean = store.getState().settings.settings[SettingKey.use_test_api_mpl];
    let apiKeys: MplApiKeysSetting | null = null;
    if (apiTestMode) {
        apiKeys = store.getState().settings.settings[SettingKey.test_api_keys_mpl];
    } else {
        apiKeys = store.getState().settings.settings[SettingKey.mpl_api_keys];
    }
    return (
        (await ApiKeyService.validateMpl(
            ecomId,
            apiTestMode,
            apiKeys?.api_key || '',
            apiKeys?.accounting_code || '',
            apiKeys?.agreement_code || ''
        )) === true
    );
};

const getShippingInfoForOrders = async (ecomId: number, orderIds: number[]) => {
    let res = await httpApi.post<MplShippingInformation[]>(`/api/ecom/${ecomId}/mpl/shipping-info`, {
        order_ids: orderIds,
    });
    let data = res.getData();
    return data;
};

const getShippingInfoForOrder = async (ecomId: number, orderId: number) => {
    let res = await httpApi.post<MplShippingInformation[]>(`/api/ecom/${ecomId}/mpl/shipping-info`, {
        order_ids: [orderId],
    });
    let data = res.getData();
    return data[0] || null;
};

const checkApiKeysWithErrorToast = async (ecomId: number) => {
    if (!(await isApiKeyValid(ecomId))) {
        // TODO: add banner!!!!
        // toastUtils.error('MPL Api Keys are invalid!');
        throw new Error('MPL Api Keys are invalid!');
    }
};

const postShipments = async (ecomId: number, orderIds: number[]) => {
    await checkApiKeysWithErrorToast(ecomId);
    const senderDetailsSetting = store.getState().settings.settings[SettingKey.sender_details];
    await SettingService.checkSenderDetailsValidityWithErrorToast(senderDetailsSetting);

    let res = await httpApi.post<MplPostShipmentsResponse>(`/api/ecom/${ecomId}/mpl/post-shipments`, {
        shopify_order_ids: orderIds,
    });
    return res.getData();
};

const closeShipments = async (ecomId: number, orderIds: number[]) => {
    await checkApiKeysWithErrorToast(ecomId);
    const senderDetailsSetting = store.getState().settings.settings[SettingKey.sender_details];
    await SettingService.checkSenderDetailsValidityWithErrorToast(senderDetailsSetting);

    let res = await httpApi.post<{ order_ids: number[] }>(`/api/ecom/${ecomId}/mpl/close-shipments`, {
        shopify_order_ids: orderIds,
    });
    return res.getData();
};

const getClosedShipmentDataForOrder = async (ecomId: number, orderId: string) => {
    let res = await httpApi.post<MplClosedShipmentData>(`/api/ecom/${ecomId}/mpl/get-closed-shipment`, {
        shopify_order_id: orderId,
    });
    return res.getData();
};

const getClosedShipmentsForEcom = async (ecomId: number) => {
    let res = await httpApi.get<{ created_at: string; ecom_id: number; id: number; manifest: string }[]>(
        `/api/ecom/${ecomId}/mpl/get-closed-shipments`
    );
    let data = res.getData();
    // console.log({ data });
    return data;
};

const downloadLabelsZip = async (ecomId: number, orderIds: number[]) => {
    let res = await httpApi.post<string>(`/api/ecom/${ecomId}/mpl/download-labels-zip`, {
        shopify_order_ids: orderIds,
    });
    let data = res.getData();
    downloadFileContent(data, `mpl_pdf_download-${self.crypto.randomUUID()}.zip`);
};

const getStatus = (
    ecomId: number,
    order: ShopifyOrder,
    mplShippingInfo: MplShippingInformation
): MplOrderStatus | null => {
    let shippingType = OrderService.getShippingType(order);
    if (
        shippingType !== ShippingType.MPL_CS &&
        shippingType !== ShippingType.MPL_COOP &&
        shippingType !== ShippingType.MPL_MEDIAMARKT &&
        shippingType !== ShippingType.MPL_MOL &&
        shippingType !== ShippingType.MPL_OFFICE
    ) {
        return null;
    }

    if (!mplShippingInfo) {
        return MplOrderStatus.SHIPMENT_AWAITING;
    }
    return mplShippingInfo.status;
};

const downloadNote = async (ecomId: number, order: Order): Promise<void> => {
    const response = await httpApi.get<{ file: string }>(`/api/ecom/${ecomId}/orders/${order.id}/shipping-note`);

    const { file } = response.getData();

    downloadFileContent(file, `$shipping_note_${order.id}.zip`);
};

// const downloadNotes = async (ecomId: number, orders: Order[]): Promise<void> => {
//     const response = await httpApi.post<{ file: string }>(`/api/ecom/${ecomId}/orders/shipping-notes`, {
//         ids: orders.map(({ id }) => parseInt(id)),
//     });
//
//     const { file } = response.getData();
//
//     downloadFileContent(file, `shipping_notes_mpl_${new Date().toISOString()}.zip`);
// };

export default {
    injectStore,
    getShippingInfoForOrders,
    getShippingInfoForOrder,
    postShipments,
    closeShipments,
    checkApiKeysWithErrorToast,
    downloadLabelsZip,
    getClosedShipmentDataForOrder,
    getClosedShipmentsForEcom,
    getStatus,
    downloadNote,
    // downloadNotes,
};
